import BaseModel from 'src/model/base.model';

export default class SignInClass extends BaseModel {
  public shouldSelectAccount: boolean;
}
